import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import UserAgentMixin from '../helpers/mixins/UserAgentMixin';
let LandingDrawer = class LandingDrawer extends Mixins(UserAgentMixin) {
    onCloseHandler() {
        this.$emit('input', false);
    }
    onGoToRoute(path, isExternal) {
        if (isExternal) {
            window.open(path);
        }
        else {
            this.$router.push(path);
        }
        this.onCloseHandler();
    }
    get linksMobile() {
        return [
            {
                title: 'Features',
                target: '/features',
                external: false,
            },
            {
                title: 'Merchants',
                target: '/merchants',
                external: false,
            },
            {
                title: 'Pricing',
                target: '/pricing',
                external: false,
            },
            {
                title: 'About Us',
                target: '/about',
                external: false,
            },
            {
                title: 'Press',
                target: '/press',
                external: false,
            },
            {
                title: 'Resources',
                target: 'https://www.youtube.com/channel/UCfI5QDh8PmAiU0outNApCkA',
                external: true,
            },
        ];
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], LandingDrawer.prototype, "value", void 0);
LandingDrawer = __decorate([
    Component
], LandingDrawer);
export default LandingDrawer;
